import { Fetch } from '../helpers/fetchWrapper';
import { useEffect, useState } from 'react';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const generalEnquiryService = {
  _url: `${process.env.REACT_APP_ENQUIRY_URL}`,

  GetGeneralEnquiries(searchQuery, refetch) {
    const [generalEnquiries, setGeneralEnquiries] = useState({
      totalItems: 0,
      generalEnquiries: [],
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getGeneralEnquirues(searchQuery))
        .then(res => {
          setGeneralEnquiries(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), refetch]);
    return {
      general_enquiries_loading: status === STATUS.LOADING,
      general_enquiries_error: status === STATUS.ERROR ? status : '',
      general_enquiries_data: generalEnquiries,
    };
  },

  async getGeneralEnquirues({
    page = 1,
    pageSize = 10,
    searchText = '',
    startDate = '',
    endDate = '',
    getAll = false,
    filterCategory = '',
  }) {
    let res = await Fetch.get(
      `${this._url}/get-all-quotation-queries?page=${page}&itemsPerPage=${pageSize}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}&getAll=${getAll}&filterCategory=${filterCategory}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return {
        generalEnquiries: res?.items,
        totalItems: res?.totalItems,
      };
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async downloadGeneralEnquiryCSV({
    page = 1,
    itemsPerPage = '',
    searchText = '',
    startDate = '',
    endDate = '',
    getAll = false,
    filterCategory = '',
    filterQueries = '',
  }) {
    let res = await Fetch.exportFile(
      `${this._url}/export-all-quotation-queries?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}&getAll=${getAll}&filterCategory=${filterCategory}&filterQueries=${filterQueries}`,
    );
    if (res.status >= 200 && res.status < 300) {
      return await res.blob();
    }

    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteGeneralEnquiry(id) {
    let res = await Fetch.delete(`${this._url}/delete-general-enquiry/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default generalEnquiryService;
